<button
  mat-button
  [type]="type"
  (click)="onClick($event)"
  [disabled]="!(isEnabled() | async)"
  [ngClass]="{
    active: isActive(),
    activeMenu: isMenuOpened,
    reversed: reversed,
    disabled: !(isEnabled() | async)
  }"
>
  <mat-icon
    class="corner"
    (click)="onClickCorner($event)"
    *ngIf="displayCorner"
    svgIcon="corner"
  ></mat-icon>
  <mat-icon
    class="icon"
    *ngIf="getIcon() as icon"
    [svgIcon]="icon"
    [ngClass]="{ 'with-corner': displayCorner }"
  ></mat-icon>
  <div class="text-of-advanced-button">
    <span
      *ngIf="displayTitle && getTitle() as label"
      innerHTML="{{ label | translate }}"
      class="title-of-button"
    ></span>
    <span *ngIf="hotButton">({{ hotButton }})</span>
  </div>
  <ng-content></ng-content>
</button>
